import facebookLogo from "./facebook-logo.svg";
import googleLogo from "./google-logo.svg";
import twitterLogo from "./twitter-logo.svg";

export type SocialProviderKey = "google" | "twitter" | "facebook";

export const SOCIAL_PROVIDERS = [
  {
    key: "google",
    name: "Google",
    logo: googleLogo,
    translationKey:
      "authentication_app.new_onboarding_flow_april_2025.signup_options.google",
  },
  {
    key: "twitter",
    name: "Twitter",
    logo: twitterLogo,
    translationKey:
      "authentication_app.new_onboarding_flow_april_2025.signup_options.twitter",
  },
  {
    key: "facebook",
    name: "Facebook",
    logo: facebookLogo,
    translationKey:
      "authentication_app.new_onboarding_flow_april_2025.signup_options.facebook",
  },
] as const;
